import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PackVerification_ds_shippingcontainers_to_verify_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseId?: number, locationId?: number, ownerId?: number, projectId?: number, shippingDate?: string, shippingContainerCode?: string, fullTextSearch?: string }): 
  Promise<{ result: { Count?: number } }> 
  {
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_shippingcontainers_to_verify_widget/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseId?: number, locationId?: number, ownerId?: number, projectId?: number, shippingDate?: string, shippingContainerCode?: string, fullTextSearch?: string    }) {
      return false;
    }
}
